import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { rem } from 'polished';
import { InteriorSelectTemplate } from './InteriorSelectTemplate';

export const InteriorSelectStyled = styled(InteriorSelectTemplate)`
    padding: ${rem(48)} 0;
    position: relative;

    .react-multiple-carousel__arrow {
        background: ${({ theme }) => theme.colors.white};
        border: 1px solid ${({ theme }) => theme.colors.black};
        border-radius: unset;
        cursor: pointer;
        padding: ${rem(3)};
        z-index: 900;

        &:hover,
        &:focus-visible {
            background: ${({ theme }) => theme.colors.black};

            &::before {
                color: ${({ theme }) => theme.colors.white};
            }
        }

        &::before {
            color: ${({ theme }) => theme.colors.black};
            font-family: revicons-override !important;
        }

        &--right {
            margin-right: -${rem(14)};
        }

        &--left {
            margin-left: -${rem(14)};
        }
    }

    .interiorImage {
        width: 100%;
        margin-top: ${rem(-20)};

        @media (min-width: ${breakpoints.md}px) {
            display: none;
        }
    }

    .interior {
        border: 1px solid ${({ theme }) => theme.colors.grey25};
        cursor: pointer;
        margin: ${rem(5)} 0;
        background: none;
        width: 100%;
        text-align: left;
        padding: 0;

        &.isSelected,
        &:hover,
        &:focus-visible {
            border: 1px solid ${({ theme }) => theme.colors.primary};
            .inner {
                border-color: ${({ theme }) => theme.colors.primary};
            }
        }

        .inner {
            border: 1px solid transparent;
            padding: ${rem(24)} ${rem(24)} ${rem(24)} ${rem(64)};

            &.disabled {
                opacity: 0.5;
            }
        }
    }

    .interiors {
        position: relative;
    }

    .interiorTitle {
        color: ${({ theme }) => theme.colors.black2};
        font-size: ${({ theme }) => theme.fontSizes.textSupBase};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        position: relative;

        .icon {
            border: 1px solid #73767a;
            width: ${rem(24)};
            height: ${rem(24)};
            position: absolute;
            left: -${rem(40)};
            top: -${rem(2)};
            border-radius: 50%;

            .selected {
                background: ${({ theme }) => theme.colors.primary};
                width: ${rem(12)};
                height: ${rem(12)};
                position: absolute;
                top: ${rem(5)};
                left: ${rem(5)};
                border-radius: 50%;
            }
        }
    }

    .interiorPrice {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        display: block;
        padding-top: ${rem(5)};
    }

    .interiorDescription {
        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
        overflow: hidden;

        ul {
            display: -webkit-box;
            -webkit-line-clamp: 6;
            -webkit-box-orient: vertical;
            overflow: hidden;
            padding-left: ${rem(20)};

            li {
                margin-left: ${rem(5)};
            }
        }

        &.withoutReduce {
            display: block;

            ul {
                display: block;
            }
        }
    }

    .interiorDescriptionLink {
        padding: ${rem(10)} 0;
        text-decoration: underline;
        cursor: pointer;
        display: block;
    }

    .interiorDescriptionLink,
    .interiorDescription {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        margin-left: -${rem(40)};
        padding: ${rem(10)} 0 0 0;
    }

    .priceSuffix {
        text-transform: lowercase;
    }

    .currencyLabel__suffix--TTC {
        padding-left: 0;
    }
`;
